/**
 * @copyright Stadtbauer
 * @description Stadtbauer news carousel
 */

import 'owl.carousel';
import $ from 'jquery';

$(document).ready(function() {
  $('.owl-carousel').owlCarousel({
    loop: true,
    margin: 30,
    items: 2,
    autoplay: true,
    autoplayTimeout: 5765,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        stagePadding: 20,
      },
      768: {
        items: 2
      }
    }
  });
});